


export class Funcionario {
  "RA_FILIAL";
  "RA_MAT";
  "RA_CC";
  "CTT_DIR";
  "CTT_GERENC";
  "CTT_COORD";
  "RA_AREA";
  "RA_CODFUNC";
  "RA_CARGODESC";
  "RJ_DESC";
  "RA_STATUS";
  "RA_NOME";
  "RA_CIC";
  "RA_RG";
  "RA_VCTOCNH";
  "RA_HABILIT";
  "RA_MUNICIP";
  "RA_ESTADO";
  "RA_TELEFON";
  "RA_TELRES";
  "RA_CEL";
  "RA_CELCORP";
  "RA_SEXO";
  "RA_NASC";
  "RA_ADMISSA";
  "RA_DEMISSA";
  "RA_HRSMES";
  "RA_EMAIL";
  "RA_CCCID";
  "RA_SSMA";
  "RA_SITFOLH";
  "RA_SITFOLHDESC";
  "RA_GERENC";
  "RA_SUBAREA";
  "RA_JORINI";
  "RA_JORTRA";
  "RA_JORFOL";
  "RA_TURNOEN";
  "RA_REFEN";
  "RA_REFSA";
  "RA_TURNOSA";
  "RA_TR";
  "RA_X_ITEM";
  "RA_USRCOD";
  "RA_USRNOME";
  "FNAME";
  "LNAME";
  "A_RA_CC";
  "FL_ROLLOUT";
  "PERSONAL_NR";
  "DT_ATUALIZACAO";
  "DT_INCLUSAO";
  "GL_NOME";
  "FL_LCM";
  "STATUS_FALTA";
  "FALTA_INI";
  "FALTA_FIN";
  "RA_ORGANIZACAO";
  "RA_PROJETO";
  "RA_MAT_GERENC";
  "PERSONAL_NR_GERENC";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Funcionario`.
   */
  static getModelName() {
    return "Funcionario";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Funcionario for dynamic purposes.
  **/
  static factory(data) {
    return new Funcionario(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'Funcionario',
      plural: 'Funcionarios',
      path: 'Funcionarios',
      properties: {
        "RA_FILIAL": {
          name: 'RA_FILIAL',
          type: 'string'
        },
        "RA_MAT": {
          name: 'RA_MAT',
          type: 'string'
        },
        "RA_CC": {
          name: 'RA_CC',
          type: 'string'
        },
        "CTT_DIR": {
          name: 'CTT_DIR',
          type: 'string'
        },
        "CTT_GERENC": {
          name: 'CTT_GERENC',
          type: 'string'
        },
        "CTT_COORD": {
          name: 'CTT_COORD',
          type: 'string'
        },
        "RA_AREA": {
          name: 'RA_AREA',
          type: 'string'
        },
        "RA_CODFUNC": {
          name: 'RA_CODFUNC',
          type: 'string'
        },
        "RA_CARGODESC": {
          name: 'RA_CARGODESC',
          type: 'string'
        },
        "RJ_DESC": {
          name: 'RJ_DESC',
          type: 'string'
        },
        "RA_STATUS": {
          name: 'RA_STATUS',
          type: 'string'
        },
        "RA_NOME": {
          name: 'RA_NOME',
          type: 'string'
        },
        "RA_CIC": {
          name: 'RA_CIC',
          type: 'string'
        },
        "RA_RG": {
          name: 'RA_RG',
          type: 'string'
        },
        "RA_VCTOCNH": {
          name: 'RA_VCTOCNH',
          type: 'string'
        },
        "RA_HABILIT": {
          name: 'RA_HABILIT',
          type: 'string'
        },
        "RA_MUNICIP": {
          name: 'RA_MUNICIP',
          type: 'string'
        },
        "RA_ESTADO": {
          name: 'RA_ESTADO',
          type: 'string'
        },
        "RA_TELEFON": {
          name: 'RA_TELEFON',
          type: 'string'
        },
        "RA_TELRES": {
          name: 'RA_TELRES',
          type: 'string'
        },
        "RA_CEL": {
          name: 'RA_CEL',
          type: 'string'
        },
        "RA_CELCORP": {
          name: 'RA_CELCORP',
          type: 'string'
        },
        "RA_SEXO": {
          name: 'RA_SEXO',
          type: 'string'
        },
        "RA_NASC": {
          name: 'RA_NASC',
          type: 'string'
        },
        "RA_ADMISSA": {
          name: 'RA_ADMISSA',
          type: 'string'
        },
        "RA_DEMISSA": {
          name: 'RA_DEMISSA',
          type: 'string'
        },
        "RA_HRSMES": {
          name: 'RA_HRSMES',
          type: 'string'
        },
        "RA_EMAIL": {
          name: 'RA_EMAIL',
          type: 'string'
        },
        "RA_CCCID": {
          name: 'RA_CCCID',
          type: 'string'
        },
        "RA_SSMA": {
          name: 'RA_SSMA',
          type: 'string'
        },
        "RA_SITFOLH": {
          name: 'RA_SITFOLH',
          type: 'string'
        },
        "RA_SITFOLHDESC": {
          name: 'RA_SITFOLHDESC',
          type: 'string'
        },
        "RA_GERENC": {
          name: 'RA_GERENC',
          type: 'string'
        },
        "RA_SUBAREA": {
          name: 'RA_SUBAREA',
          type: 'string'
        },
        "RA_JORINI": {
          name: 'RA_JORINI',
          type: 'string'
        },
        "RA_JORTRA": {
          name: 'RA_JORTRA',
          type: 'string'
        },
        "RA_JORFOL": {
          name: 'RA_JORFOL',
          type: 'string'
        },
        "RA_TURNOEN": {
          name: 'RA_TURNOEN',
          type: 'string'
        },
        "RA_REFEN": {
          name: 'RA_REFEN',
          type: 'string'
        },
        "RA_REFSA": {
          name: 'RA_REFSA',
          type: 'string'
        },
        "RA_TURNOSA": {
          name: 'RA_TURNOSA',
          type: 'string'
        },
        "RA_TR": {
          name: 'RA_TR',
          type: 'string'
        },
        "RA_X_ITEM": {
          name: 'RA_X_ITEM',
          type: 'string'
        },
        "RA_USRCOD": {
          name: 'RA_USRCOD',
          type: 'string'
        },
        "RA_USRNOME": {
          name: 'RA_USRNOME',
          type: 'string'
        },
        "FNAME": {
          name: 'FNAME',
          type: 'string'
        },
        "LNAME": {
          name: 'LNAME',
          type: 'string'
        },
        "A_RA_CC": {
          name: 'A_RA_CC',
          type: 'string'
        },
        "FL_ROLLOUT": {
          name: 'FL_ROLLOUT',
          type: 'string'
        },
        "PERSONAL_NR": {
          name: 'PERSONAL_NR',
          type: 'string'
        },
        "DT_ATUALIZACAO": {
          name: 'DT_ATUALIZACAO',
          type: 'Date'
        },
        "DT_INCLUSAO": {
          name: 'DT_INCLUSAO',
          type: 'Date'
        },
        "GL_NOME": {
          name: 'GL_NOME',
          type: 'string'
        },
        "FL_LCM": {
          name: 'FL_LCM',
          type: 'string'
        },
        "STATUS_FALTA": {
          name: 'STATUS_FALTA',
          type: 'string'
        },
        "FALTA_INI": {
          name: 'FALTA_INI',
          type: 'Date'
        },
        "FALTA_FIN": {
          name: 'FALTA_FIN',
          type: 'Date'
        },
        "RA_ORGANIZACAO": {
          name: 'RA_ORGANIZACAO',
          type: 'string'
        },
        "RA_PROJETO": {
          name: 'RA_PROJETO',
          type: 'string'
        },
        "RA_MAT_GERENC": {
          name: 'RA_MAT_GERENC',
          type: 'string'
        },
        "PERSONAL_NR_GERENC": {
          name: 'PERSONAL_NR_GERENC',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/Funcionario.js